export const PROVINCES = [
  { view: 'Agrigento', value: 15, id: 'agrigento' },
  { view: 'Alessandria', value: 10, id: 'alessandria' },
  { view: 'Ancona', value: 15, id: 'ancona' },
  { view: 'Aosta', value: 5, id: 'aosta' },
  { view: 'Ascoli Piceno', value: 10, id: 'ascolipiceno' },
  { view: "L'Aquila", value: 15, id: 'laquila' },
  { view: 'Arezzo', value: 10, id: 'arezzo' },
  { view: 'Asti', value: 10, id: 'asti' },
  { view: 'Avellino', value: 15, id: 'avellino' },
  { view: 'Bari', value: 15, id: 'bari' },
  { view: 'Bergamo', value: 5, id: 'bergamo' },
  { view: 'Biella', value: 5, id: 'biella' },
  { view: 'Belluno', value: 5, id: 'belluno' },
  { view: 'Benevento', value: 15, id: 'benevento' },
  { view: 'Bologna', value: 5, id: 'bologna' },
  { view: 'Brindisi', value: 15, id: 'brindisi' },
  { view: 'Brescia', value: 10, id: 'brescia' },
  { view: 'Barletta Andria Trani', value: 15, id: 'barlettaandriatrani' },
  { view: 'Bolzano', value: 10, id: 'bolzano' },
  { view: 'Cagliari', value: 15, id: 'cagliari' },
  { view: 'Campobasso', value: 15, id: 'campobasso' },
  { view: 'Caserta', value: 15, id: 'caserta' },
  { view: 'Chieti', value: 10, id: 'chieti' },
  { view: 'Caltanissetta', value: 15, id: 'caltanissetta' },
  { view: 'Cuneo', value: 5, id: 'cuneo' },
  { view: 'Como', value: 10, id: 'como' },
  { view: 'Cremona', value: 10, id: 'cremona' },
  { view: 'Cosenza', value: 15, id: 'cosenza' },
  { view: 'Catania', value: 15, id: 'catania' },
  { view: 'Catanzaro', value: 15, id: 'catanzaro' },
  { view: 'Enna', value: 15, id: 'enna' },
  { view: 'Forlì Cesena', value: 5, id: 'forlicesena' },
  { view: 'Ferrara', value: 10, id: 'ferrara' },
  { view: 'Foggia', value: 15, id: 'foggia' },
  { view: 'Firenze', value: 10, id: 'firenze' },
  { view: 'Fermo', value: 10, id: 'fermo' },
  { view: 'Frosinone', value: 15, id: 'frosinone' },
  { view: 'Genova', value: 10, id: 'genova' },
  { view: 'Gorizia', value: 15, id: 'gorizia' },
  { view: 'Grosseto', value: 10, id: 'grosseto' },
  { view: 'Imperia', value: 15, id: 'imperia' },
  { view: 'Isernia', value: 15, id: 'isernia' },
  { view: 'Crotone', value: 15, id: 'crotone' },
  { view: 'Lecco', value: 10, id: 'lecco' },
  { view: 'Lecce', value: 15, id: 'lecce' },
  { view: 'Livorno', value: 10, id: 'livorno' },
  { view: 'Lodi', value: 10, id: 'lodi' },
  { view: 'Latina', value: 15, id: 'latina' },
  { view: 'Lucca', value: 5, id: 'lucca' },
  { view: 'Monza Brianza', value: 10, id: 'monzabrianza' },
  { view: 'Macerata', value: 10, id: 'macerata' },
  { view: 'Messina', value: 15, id: 'messina' },
  { view: 'Milano', value: 10, id: 'milano' },
  { view: 'Mantova', value: 10, id: 'mantova' },
  { view: 'Modena', value: 5, id: 'modena' },
  { view: 'Massa Carrara', value: 10, id: 'massacarrara' },
  { view: 'Matera', value: 15, id: 'matera' },
  { view: 'Napoli', value: 15, id: 'napoli' },
  { view: 'Novara', value: 5, id: 'novara' },
  { view: 'Nuoro', value: 15, id: 'nuoro' },
  { view: 'Oristano', value: 15, id: 'oristano' },
  { view: 'Palermo', value: 15, id: 'palermo' },
  { view: 'Piacenza', value: 10, id: 'piacenza' },
  { view: 'Padova', value: 10, id: 'padova' },
  { view: 'Pescara', value: 10, id: 'pescara' },
  { view: 'Perugia', value: 10, id: 'perugia' },
  { view: 'Pisa', value: 10, id: 'pisa' },
  { view: 'Pordenone', value: 10, id: 'pordenone' },
  { view: 'Prato', value: 15, id: 'prato' },
  { view: 'Parma', value: 5, id: 'parma' },
  { view: 'Pistoia', value: 10, id: 'pistoia' },
  { view: 'Pesaro e Urbino', value: 5, id: 'pesaroeurbino' },
  { view: 'Pavia', value: 10, id: 'pavia' },
  { view: 'Potenza', value: 15, id: 'potenza' },
  { view: 'Ravenna', value: 5, id: 'ravenna' },
  { view: 'Reggio di Calabria', value: 15, id: 'reggiodicalabria' },
  { view: "Reggio nell'Emilia", value: 5, id: 'reggionellemilia' },
  { view: 'Ragusa', value: 15, id: 'ragusa' },
  { view: 'Rieti', value: 10, id: 'rieti' },
  { view: 'Roma', value: 10, id: 'roma' },
  { view: 'Rimini', value: 10, id: 'rimini' },
  { view: 'Rovigo', value: 10, id: 'rovigo' },
  { view: 'Salerno', value: 15, id: 'salerno' },
  { view: 'Siena', value: 5, id: 'siena' },
  { view: 'Sondrio', value: 5, id: 'sondrio' },
  { view: 'La Spezia', value: 15, id: 'laspezia' },
  { view: 'Siracusa', value: 15, id: 'siracusa' },
  { view: 'Sassari', value: 15, id: 'sassari' },
  { view: 'Sud Sardegna', value: 15, id: 'sudsardegna' },
  { view: 'Savona', value: 15, id: 'savona' },
  { view: 'Taranto', value: 15, id: 'taranto' },
  { view: 'Teramo', value: 10, id: 'teramo' },
  { view: 'Trento', value: 5, id: 'trento' },
  { view: 'Torino', value: 5, id: 'torino' },
  { view: 'Trapani', value: 15, id: 'trapani' },
  { view: 'Terni', value: 10, id: 'terni' },
  { view: 'Trieste', value: 10, id: 'trieste' },
  { view: 'Treviso', value: 5, id: 'treviso' },
  { view: 'Udine', value: 10, id: 'udine' },
  { view: 'Varese', value: 10, id: 'varese' },
  { view: 'Verbano Cusio Ossola', value: 10, id: 'verbanocusioossola' },
  { view: 'Vercelli', value: 15, id: 'vercelli' },
  { view: 'Venezia', value: 10, id: 'venezia' },
  { view: 'Vicenza', value: 5, id: 'vicenza' },
  { view: 'Verona', value: 5, id: 'verona' },
  { view: 'Viterbo', value: 10, id: 'viterbo' },
  { view: 'Vibo Valentia', value: 15, id: 'vibovalentia' },
];
